import { InjectionToken } from '@angular/core';

export interface Config {
    apiGateway: string;
}

export const ConfigService = new InjectionToken<Config>('Config');

export interface AumicoCoreConfig extends Config {
    apiGateway: string;
    serviceId: string;
    currentLanguageKey?: string;
    // if true, the service is used in the prototyping framework
    // so that all calls respond with 200 success and predefined data, if not otherwise defined
    prototype?: boolean;
    // if false, suppresses the user-notifications websocket connection (defaults to true)
    enableNotificationsSocket?: boolean;
}

export const AumicoCoreConfigService = new InjectionToken<AumicoCoreConfig>('Config');
